module.exports = __webpack_public_path__ + "static/media/IMG_4305.36d95d2c.JPG";